import React, {Component} from 'react';
import {connect} from 'react-redux';

import AddPropertyForm from '../../owner/properties/AddPropertyForm';
import PolyUtil from "../../../util/PolyUtil";

class OwnerProperty extends Component {
    render() {
        return (
            <div>
                <h3>Great. Let's see who's interested in your place:</h3>
                <hr/>
                <AddPropertyForm onSubmit={(data) => {
                    data.landlord_email = this.props.landlord_email;
                    data.landlord_phone = this.props.landlord_phone;
                    this.props.fetchReach(data);
                }}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    landlord_email: state.activeUser.email,
    landlord_phone: state.activeUser.phone
});

const mapDispatchToProps = (dispatch, props) => ({
    fetchReach(data) {
        return PolyUtil.fetchWrapper('/api/landlord/properties/reach/',
            {
                method: 'POST',
                body: JSON.stringify(data)
            }
        ).then((data) => {
            props.setReach(data);
            props.onContinue();
        }).catch((error) => {
            console.log("Error: ", error);
        });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnerProperty);


// WEBPACK FOOTER //
// ./src/containers/authentication/OwnerRegisterFlow/OwnerProperty.js